import { DATE_TYPE } from "../../../utils/Types";

export const GET_USERS_LIST_QUERY_KEY = "GET_USERS_LIST_QUERY_KEY";
export const GET_USER_DETAIL_QUERY_KEY = "GET_USER_DETAIL_QUERY_KEY";
export const GET_NEW_USER_COUNT_QUERY_KEY = "GET_NEW_USER_COUNT_QUERY_KEY";

export enum USER_ROLES {
  NURSE = "Nurse",
  CHARGE_NURSE = "Charge Nurse",
  OT_MANAGER = "OT Manager",
  ADMIN = "Admin",
  SUPER_ADMIN = "Super Admin",
  CODING_ADMIN = "Coding Admin",
  ANESTHELOGIST = "Anesthesiologist",
  SURGEON = "Surgeon",
  ROOM_CLEAN_MANAGER = "Room Clean Manager",
}

export enum USER_PERMISSIONS {
  NURSE = "Nurse",
  CHARGE_NURSE = "Charge Nurse",
  OT_MANAGER = "OT Manager",
  ADMIN = "Admin",
  SUPER_ADMIN = "Super Admin",
  CODING_ADMIN = "Coding Admin",
  ANESTHELOGIST = "Anesthesiologist",
  SURGEON = "Surgeon",
  ROOM_CLEAN_MANAGER = "Room Clean Manager",
}

export type USER = {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  isSuperUser: boolean;
  dateJoined: DATE_TYPE;
  tenantId: string;
  hospitalId: string;
  realm: string;
  role: string;
  iamId: string;
  permission: Array<USER_PERMISSIONS>;
  emrStatus?: boolean;
  notificationConfig: {
    id: number;
    countryCode: string;
    phoneNumber: string;
    turnoverTimeToggle: boolean;
    firstCaseTimeToggle: boolean;
    isEligibleForAlerts: boolean;
    createdAt: string;
    updatedAt: string;
  };
  emrDetail?: {
    createdAt?: string;
    emrId?: string;
    emrName?: string;
    emrStatus?: string;
    id?: number;
    updatedAt?: string;
    emrResourceType?: string;
  };
  status: USER_STATUS;
  primaryColor?: string;
  secondaryColor?: string;
};

export enum USER_STATUS {
  ACTIVE = "Active",
  DEACTIVATE = "Deactivate",
  PENDING = "Pending",
  INCOMPLETE = "Incomplete",
}

export type USER_BY_ROLE = USER & {
  active: boolean;
};
